import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'

const rowSx = { '&:last-child td, &:last-child th': { border: 0 } }

export default function SimpleTable({ columns, rows, ...rest }) {
  return (
    <TableContainer {...rest}>
      <Table size="small">
        <TableHead>
          <TableRow>
            {columns.map(col =>
              <TableCell key={col.field}>{col.headerName}</TableCell>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map(row => (
            <TableRow key={row.id} sx={rowSx}>
              {columns.map(col =>
                <TableCell key={col.field}>{row[col.field]}</TableCell>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}